export default __webpack_public_path__ + "d16ddfb7c16463106ce08d976a901695.jpg";